import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { Card, CardHeader, CardTitle } from "@/components/ui/Card";

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect ke login jika user belum punya userId host
    if (!localStorage.getItem("fotomomen_userId")) {
      navigate("/auth/google/callback");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="px-6 py-4 border-b bg-white flex justify-between items-center">
        <h1 className="text-xl font-bold text-slate-900">Host Dashboard</h1>
        <Button variant="ghost" size="sm" onClick={() => navigate("/auth/google/callback")}>
          Login / Re-auth
        </Button>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="grid gap-6">
          <Card className="p-6">
            <CardHeader>
              <CardTitle>Event Anda</CardTitle>
            </CardHeader>
            <p className="text-sm text-slate-500">Silakan buat event baru atau pilih event yang sudah dibuat.</p>
            <Button onClick={() => navigate("/events/new")} className="mt-3 w-full">
              Buat Event Baru
            </Button>
          </Card>
        </div>
      </main>
    </div>
  );
}